import * as React from 'react';

import Box from '@mui/material/Box';
import { useParams } from 'react-router-dom';
import AppPage from '@/ui/AppPage/AppPage';
import Permissions from '@/lib/permissions';

import DataController from '@/lib/DataController';
import DynamicFormForm from './DynamicFormForm';
import DynamicFormsModel from '@/models/dynamic_forms_model';

const DynamicFormPage = () =>  {
  const { id } = useParams();
  const dc = new DataController(DynamicFormsModel);

  const recordId = parseInt(id || '', 10);
  // console.log("record id", recordId)

  return (
    <AppPage
      titlett="admin:page.dynamic_form"
      needPermission={[Permissions.Administration]}
    >
      <Box m={2}>
        <DynamicFormForm dc={dc} recordId={recordId} mode="update" form="update" />
      </Box>
    </AppPage>
  );
}

export default DynamicFormPage;
